import React from 'react';
import PropTypes from 'prop-types';

const ImporterModalBrowserBreadcrumbs = ({
  importer,
  path,
  pathElements,
  setPath,
}) => {
  const getPathParts = () => {
    if (pathElements.length > 0) {
      return pathElements;
    }

    let ppath = '';
    const parts = [];
    path.split('/').forEach((part) => {
      if (part) {
        ppath = `${ppath}/${part}`;
        parts.push({
          path: ppath,
          label: ppath === '/' ? importer.name : part,
        });
      }
    });
    return parts;
  };

  const handleSetPath = (e) => {
    e.preventDefault();
    setPath(e.target.getAttribute('data-path'));
  };

  const pathParts = getPathParts();

  if (!importer) {
    return null;
  }

  return (
    <ul className="modal-import-browser-breadcrumbs">
      <li>
        <a href="#go" data-path="/" onClick={handleSetPath}>{importer.name}</a>
      </li>
      {pathParts.map((pp, idx) => (
        <li key={pp.path}>
          {idx < pathParts.length - 1 ? (
            <a href="#go" data-path={pp.path} onClick={handleSetPath}>
              {pp.label}
            </a>
          ) : (
            <span>{pp.label}</span>
          )}
        </li>
      ))}
    </ul>
  );
};

ImporterModalBrowserBreadcrumbs.propTypes = {
  importer: PropTypes.object,
  path: PropTypes.string.isRequired,
  pathElements: PropTypes.array.isRequired,
  setPath: PropTypes.func.isRequired,
};

ImporterModalBrowserBreadcrumbs.defaultProps = {
  importer: null,
};

export default ImporterModalBrowserBreadcrumbs;
